import { get, post } from './utils';

export async function getDriveStatus(password) {
  return get('/google-drive/status', { password });
}

export async function getDriveAuthUrl({ password, returnUrl, clientId, clientSecret }) {
  return post('/google-drive/auth-url', {
    password,
    returnUrl,
    clientId: clientId || undefined,
    clientSecret: clientSecret || undefined,
  });
}
